export enum TabDirection {
  Horizontal,
  Vertical,
}
